import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../store/auth";
import CombavaOrbitalCore from "./CombavaOrbitalCore";

interface LandingHeroProps {
  className?: string;
}

export default function LandingHero({ className = "" }: LandingHeroProps) {
  const navigate = useNavigate();
  const { user } = useAuthStore();

  const handleCta = () => {
    if (user) {
      navigate("/terminal");
    } else {
      // Trigger sign in / join modal if available, or route to terminal
      const authBtn = document.querySelector<HTMLButtonElement>("[data-auth-trigger]");
      if (authBtn) {
        authBtn.click();
      } else {
        navigate("/terminal");
      }
    }
  };

  return (
    <section className={`w-full px-6 sm:px-10 md:px-16 pt-8 sm:pt-12 md:pt-14 pb-14 sm:pb-18 md:pb-20 relative z-10 ${className}`}>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center">
        {/* Left Column: Copy & CTA (50% width on desktop) */}
        <div className="flex flex-col items-start">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-[64px] font-bold text-white tracking-tight leading-[1.08]">
            Sharper signals.
            <br />
            Fewer lemons.
          </h1>

          <p className="mt-6 text-base sm:text-lg text-gray-300 font-normal max-w-lg leading-relaxed">
            Auditable company financials, filings, and official economic releases.
          </p>

          <div className="mt-8 sm:mt-10 flex flex-wrap items-center gap-4">
            <button
              onClick={handleCta}
              className="px-7 py-3.5 text-sm font-semibold text-black bg-white rounded-full hover:bg-gray-100 hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all cursor-pointer whitespace-nowrap shadow-md active:scale-95"
            >
              Create a free account
            </button>

            <button
              onClick={() => navigate("/terminal")}
              className="px-6 py-3.5 text-sm font-medium text-gray-300 hover:text-white rounded-full border border-white/15 hover:border-white/30 hover:bg-white/5 transition-all cursor-pointer whitespace-nowrap"
            >
              Launch terminal &rarr;
            </button>
          </div>
        </div>

        {/* Right Column: Interactive 3D Citrus Core Animation (50% width on desktop, centered) */}
        <div className="relative w-full flex items-center justify-center">
          {/* Subtle ambient green glow centered behind graphic */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 sm:w-96 sm:h-96 bg-[#15DE9B]/10 rounded-full blur-3xl pointer-events-none" />
          <CombavaOrbitalCore />
        </div>
      </div>
    </section>
  );
}
